import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import ClaimIntakeForm from './components/ClaimIntakeForm';
import ClaimsList from './components/ClaimsList';
import ClaimDetail from './components/ClaimDetail';

function NavBar() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <nav style={styles.nav}>
      <div style={styles.navBrand}>
        <span style={styles.logo}>⚕</span>
        <span style={styles.brandText}>Insurance Claim AI</span>
      </div>
      <div style={styles.navLinks}>
        <Link to="/" style={{ ...styles.navLink, ...(isActive('/') ? styles.navLinkActive : {}) }}>
          New Claim
        </Link>
        <Link to="/claims" style={{ ...styles.navLink, ...(isActive('/claims') || location.pathname.startsWith('/claims/') ? styles.navLinkActive : {}) }}>
          Dashboard
        </Link>
      </div>
    </nav>
  );
}

function App() {
  const [lastResult, setLastResult] = useState(null);

  return (
    <Router>
      <div style={styles.app}>
        <NavBar />
        <main style={styles.main}>
          <Routes>
            <Route path="/" element={<ClaimIntakeForm onSubmitSuccess={setLastResult} />} />
            <Route path="/claims" element={<ClaimsList />} />
            <Route path="/claims/:claimId" element={<ClaimDetail />} />
          </Routes>
        </main>
        <footer style={styles.footer}>
          Cashless Medical Insurance Claim Processing — Powered by Amazon Bedrock
        </footer>
      </div>
    </Router>
  );
}

const styles = {
  app: { minHeight: '100vh', background: '#f7fafc', display: 'flex', flexDirection: 'column' },
  nav: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 32px', background: '#1a365d', color: '#fff' },
  navBrand: { display: 'flex', alignItems: 'center', gap: 10 },
  logo: { fontSize: 28 },
  brandText: { fontSize: 18, fontWeight: 700 },
  navLinks: { display: 'flex', gap: 8 },
  navLink: { padding: '8px 20px', color: '#e2e8f0', textDecoration: 'none', borderRadius: 6, fontSize: 14, fontWeight: 500, transition: 'all 0.2s' },
  navLinkActive: { background: '#2b6cb0', color: '#fff' },
  main: { flex: 1, padding: '24px 16px' },
  footer: { textAlign: 'center', padding: 16, color: '#a0aec0', fontSize: 12, borderTop: '1px solid #e2e8f0' },
};

export default App;
